var o = Object.defineProperty;
var h = (i, a, e) => a in i ? o(i, a, { enumerable: !0, configurable: !0, writable: !0, value: e }) : i[a] = e;
var r = (i, a, e) => h(i, typeof a != "symbol" ? a + "" : a, e);
class u extends HTMLElement {
  constructor() {
    var e;
    super();
    r(this, "drawLoop", () => {
      this.draw(), this.step = window.requestAnimationFrame(this.drawLoop);
    });
    r(this, "drawPause", () => {
      window.cancelAnimationFrame(this.step), this.step = void 0;
    });
    r(this, "drawInit", () => {
      this.mediaPlayer.addEventListener("loaded-data", this.draw, !1), this.mediaPlayer.addEventListener("seeked", this.draw, !1), this.mediaPlayer.addEventListener("play", this.drawLoop, !1), this.mediaPlayer.addEventListener("pause", this.drawPause, !1), this.mediaPlayer.addEventListener("ended", this.drawPause, !1);
    });
    r(this, "drawCleanup", () => {
      this.mediaPlayer.removeEventListener("loaded-data", this.draw, !1), this.mediaPlayer.removeEventListener("seeked", this.draw, !1), this.mediaPlayer.removeEventListener("play", this.drawLoop, !1), this.mediaPlayer.removeEventListener("pause", this.drawPause, !1), this.mediaPlayer.removeEventListener("ended", this.drawPause, !1);
    });
    this.mediaPlayer = this.querySelector("media-player"), this.mediaPlayer && (this.overlay = this.querySelector("[data-video-overlay]"), this.isPortrait = this.mediaPlayer.hasAttribute("data-portrait"), this.canAutoplay = this.mediaPlayer.hasAttribute("data-can-autoplay"), this.enablePreview = this.mediaPlayer.hasAttribute("data-enable-preview"), this.enableStudioHeaderToggle = this.mediaPlayer.hasAttribute(
      "data-hide-studio-header"
    ), this.poster = this.querySelector("[data-poster]"), this.content = this.querySelector("[data-video-player-content]"), this.playButton = this.querySelector("[data-video-player-play]"), this.toggleButton = this.querySelector("[data-video-player-toggle]"), this.canvas = this.querySelector("[data-canvas]"), this.ctx = (e = this.canvas) == null ? void 0 : e.getContext("2d"), this.step = null, this.attachEventListeners());
  }
  draw() {
    var e;
    (e = this.ctx) == null || e.drawImage(
      this.querySelector("video"),
      0,
      0,
      this.canvas.width,
      this.canvas.height
    );
  }
  connectedCallback() {
    this.setUpObservers(), !this.isReducedMotion && this.canvas && this.drawInit();
  }
  init() {
    (async () => (await import("./chunk-vidstack-player-C4n26Wrd.js").then((e) => e.v), await import("./chunk-vidstack-player-default-layout-Dugq1An-.js"), await import("./chunk-vidstack-player-ui-Nml9hswv.js")))();
  }
  setUpObservers() {
    const e = {
      root: null,
      threshold: 0.1
    }, t = new IntersectionObserver((s) => {
      s.forEach((d) => {
        d.isIntersecting && (this.init(), t.disconnect());
      });
    }, e);
    t.observe(this);
  }
  disconnectedCallback() {
    this.drawCleanup();
  }
  onInitialLoad() {
    if (this.mediaPlayer.controlsDelay = 2e3, this.mediaPlayer.clipStartTime = this.mediaPlayer.clipStartTime || 0, this.enablePreview) {
      this.mediaPlayer.loop = !0;
      const e = this.mediaPlayer.clipEndTime < this.mediaPlayer.clipStartTime ? this.mediaPlayer.clipStartTime + 15 : this.mediaPlayer.clipEndTime;
      this.mediaPlayer.clipEndTime = e;
    }
    this.mediaPlayer.classList.add("opacity-100");
  }
  toggleStudioHeader(e) {
    const t = document.querySelector("[data-studio-header]");
    if (!t) return;
    const s = window.matchMedia("(max-width: 768px)").matches;
    !this.isPortrait && s || (e && !t.hasAttribute("data-hidden") ? (t.setAttribute("data-hidden", ""), t.classList.add("pointer-events-none"), t.classList.add("opacity-0")) : (t.removeAttribute("data-hidden"), t.classList.remove("pointer-events-none"), t.classList.remove("opacity-0")));
  }
  onPlay(e) {
    var t;
    this.isPortrait && window.matchMedia("(max-width: 768px)").matches ? setTimeout(() => {
      this.setAttribute("data-interacted", !0);
    }, 150) : this.setAttribute("data-interacted", !0), this.setAttribute("data-playing", !0), this.enableStudioHeaderToggle && this.toggleStudioHeader(!0), (t = this.mediaPlayer.querySelector("media-controls")) == null || t.setAttribute("data-visible", ""), this.mediaPlayer.clipEndTime = 0, this.mediaPlayer.clipStartTime = 0, this.mediaPlayer.loop = !1, e && (setTimeout(() => {
      this.mediaPlayer.currentTime = 0, this.mediaPlayer.muted = !1;
    }, 50), this.mediaPlayer.play());
  }
  onPause() {
    this.toggleButton.dataset.playing = "false", this.toggleButton.setAttribute("aria-label", "Play video"), this.setAttribute("data-playing", !1), this.enableStudioHeaderToggle && this.toggleStudioHeader(!1);
  }
  onToggle() {
    this.mediaPlayer.hasAttribute("data-playing") && this.mediaPlayer.pause(), this.mediaPlayer.hasAttribute("data-paused") && this.mediaPlayer.play();
  }
  get isReducedMotion() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }
  attachEventListeners() {
    var e, t, s, d, l, n;
    (e = this.playButton) == null || e.addEventListener("click", () => this.onPlay(!0)), (t = this.mediaPlayer) == null || t.addEventListener(
      "media-play-request",
      () => this.onPlay(!1)
    ), (s = this.mediaPlayer) == null || s.addEventListener("loaded-data", () => {
      this.onInitialLoad();
    }), this.toggleButton && (this.toggleButton.addEventListener("click", () => this.onToggle()), (d = this.mediaPlayer) == null || d.addEventListener("play", () => {
      this.toggleButton.dataset.playing = "true", this.toggleButton.setAttribute("aria-label", "Pause video");
    }), (l = this.mediaPlayer) == null || l.addEventListener("pause", () => {
      this.onPause();
    })), (n = this.mediaPlayer) == null || n.addEventListener("auto-play", () => {
      if (this.isReducedMotion) {
        if (this.mediaPlayer.pause(), !this.toggleButton)
          return;
        setTimeout(() => {
          this.toggleButton.dataset.playing = "false", this.toggleButton.setAttribute("aria-label", "Play video");
        }, 200);
      }
    });
  }
}
if (!window.customElements.get("video-player")) {
  {
    const i = document.createElement("link");
    i.href = "https://cdn.jsdelivr.net/npm/hls.js@1.5.18/dist/hls.min.js", i.rel = "preconnect", document.head.appendChild(i);
  }
  window.customElements.define("video-player", u);
}
